import { Partner } from "../../shared/classes/partner.class";
import { EMPTY_STRING } from "../../shared/constants/empty-string.constant";
import PATHS from "../../shared/constants/paths.constant";
import { CountryCodes } from "../../shared/enums/country-codes.enum";
import { Prefixes } from "../../shared/enums/prefixes.enum";
import { TeamNamesEnum } from "../../shared/enums/team-names.enum";
import { PartnerInterface } from "../../shared/interfaces/partner.interface";
import ExternalAnchor from "../../src/components/UI/ExternalAnchor";

export function getPartners(): Partner[] {
      return partners.map(
            p =>
                  new Partner(
                        p.id,
                        p.excluded,
                        p.name,
                        p.organisation,
                        p.imageUrlPublic,
                        p.team,
                        p.social,
                        p.mapInformation,
                        p.content,
                        p.countryCode,
                        p.bgImageForCard,
                        p.negativeImage
                  )
      );
}

const partners: PartnerInterface[] = [

      {
            id: `${Prefixes.PARTNER_ID}001`,
            excluded: false,
            name: 'Universität Wien',
            team: TeamNamesEnum.UNIVIE,
            organisation: 'Universität Wien',
            countryCode: CountryCodes.Austria,
            social: {
                  email: EMPTY_STRING,
                  twitter: 'https://twitter.com/univienna/?key=quicklink',
                  linkedin:
                        'https://www.linkedin.com/school/univienna/?originalSubdomain=at&?key=quicklink',
                  personalWeb: '#!',
                  institutionalLink: 'https://www.univie.ac.at/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part001.UniWien.webp`,
            content: {
                  curriculum: <p>The University of Vienna, also known as Universität Wien, is a public research university located in Vienna, Austria. It was founded by Duke Rudolph IV in 1365, making it one of the oldest universities in the German-speaking world. The university is a prominent institution in Austria and plays a vital role in the internationalization of the tertiary sector in the country.
                        <br />
                        The University of Vienna is organized into 15 faculties, four centers, and one inter-university organizational unit. It offers a wide range of academic disciplines and is known for its excellence in teaching and research. With a diverse community of students and faculty, the university provides a vibrant and intellectually stimulating environment for learning and collaboration.
                        <br />
                        At the University of Vienna, approximately 7,500 researchers conduct both basic and applied research across various fields. The university is committed to advancing knowledge and contributing to society through its research endeavors. It has made significant contributions to scientific discoveries, cultural studies, and social sciences.
                        <br />
                        Overall, the University of Vienna is a prestigious institution with a rich history and a strong commitment to academic excellence and research. It continues to be a leading center of learning and innovation in Austria and attracts students and scholars from around the world.</p>,
            },
            mapInformation: {
                  isAdvisoryBoard: true,
                  mapLocation: { coordinates: [48.21420775246007, 16.359689511372043] },
            },
            bgImageForCard: `${PATHS.teamBackgroundImages}b001_uwien.webp`,
            negativeImage: `${PATHS.logos}logo002.UniWien_logo_white_no_BG.webp`,
      },
      {
            id: `${Prefixes.PARTNER_ID}002`,
            excluded: false,
            team: TeamNamesEnum.USAL,
            name: 'USM',
            organisation: 'University of Salford',
            countryCode: CountryCodes.GreatBritain,
            social: {
                  email: '#!',
                  twitter: 'https://twitter.com/SalfordUni',
                  linkedin:
                        'https://www.linkedin.com/school/university-of-salford/?originalSubdomain=uk',
                  personalWeb: '#!',
                  institutionalLink: 'https://www.salford.ac.uk/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part002.salford.webp`,
            content: {
                  curriculum: (
                        <p>
                              The University of Salford (USAL) is a public research university in
                              Salford, Greater Manchester with more than 20,000 students. From its
                              inception as a royal institute in 1896, through the period as College
                              of Advanced Technology during the post-war period, to its university
                              charter status in 1967, the University of Salford has pioneered
                              original research that is ready for industry application. Today, this
                              founding ethos is embodied in our strategic commitment to industry
                              collaboration. By applying our holistic, interdisciplinary approach,
                              informed by societal challenges and changes, we strive to solve many
                              of the complex global challenges we currently face. The University is
                              committed to the production of innovative and impactful research and
                              its application through partnership working. USAL is widely regarded
                              as one of the UK&#39;s leading enterprise universities, due to its links
                              with industry, commerce and the community. The University of Salford´s
                              (USAL) particular strengths include research and teaching in media,
                              culture, and technology, and its links to a range of media companies
                              located at MediaCityUK at Salford Quays including the BBC.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: true,
                  mapLocation: { coordinates: [-37.808121267272426, 144.9639707848136] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part002.salford-negative.webp`
      },

      {
            id: `${Prefixes.PARTNER_ID}003`,
            excluded: false,
            team: TeamNamesEnum.TAU,
            name: 'TAU',
            organisation: 'Tampere University',
            countryCode: CountryCodes.Finland,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.tuni.fi/en/about-us/tampere-university',
                  institutionalLink: 'https://www.tuni.fi/en/about-us/tampere-university',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part003.tampere.webp`,
            content: {
                  curriculum: (
                        <p>
                              Tampere University is one of the most multidisciplinary universities
                              in Finland. We bring together research and education in technology,
                              health and society. The University is known for its excellence in
                              teaching and research and it collaborates with hundreds of
                              universities and organisations worldwide. Our community consists of
                              21,000 students and over 4,000 staff members from more than 80
                              countries.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [51.91739981784009, 4.526345603309724] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part003.tampere-negative.webp`
      },
      {
            id: `${Prefixes.PARTNER_ID}004`,
            excluded: false,
            team: TeamNamesEnum.IWM,
            name: 'IWM',
            organisation: 'Imperial War Museums',
            countryCode: CountryCodes.GreatBritain,
            social: {
                  email: EMPTY_STRING,
                  twitter: '',
                  linkedin: '',
                  personalWeb: 'https://www.iwm.org.uk/',
                  institutionalLink: 'https://www.iwm.org.uk/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part004.IWM-negative.webp`,
            content: {
                  curriculum: (
                        <p>
                              <ExternalAnchor
                                    link='https://www.iwm.org.uk/'
                                    prevText='IWM'
                              />
                              is a global authority on conflict and its impact on people&#39;s lives. We
                              collect objects and stories that give an insight into people&#39;s
                              experiences of war, preserve them for future generations and bring
                              them to today&#39;s audiences in the most powerful way possible. We are a
                              family of five museums uncovering the causes, course and consequences
                              of war, from the First World War to present-day conflict. The museum
                              has been an Independent Research Organisation since 2010 and has led
                              several Arts Humanities and Research Council (AHRC) funded projects,
                              as well as hosting 29 embedded PhD students under the AHRC
                              Collaborative Doctoral Partnership scheme.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part004.IWM-negative.webp`
      },
      {
            id: `${Prefixes.PARTNER_ID}005`,
            excluded: false,
            team: TeamNamesEnum.BUAS,
            name: 'BUAS',
            organisation: 'Breda University of Applied Science',
            countryCode: CountryCodes.Netherlands,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.buas.nl/en',
                  institutionalLink: 'https://www.buas.nl/en',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part005.Breda.webp`,
            content: {
                  curriculum: (
                        <p>
                              BUas is a medium-sized higher education institute based in Breda, The
                              Netherlands. We host 7,000 Dutch and international students from 80
                              countries, and offer bachelor’s, master’s, and Professional Doctorate
                              programmes. Our AI, Games, & Media R&D team comprises experienced game
                              developers and researchers. Our in-house development team, Cradle,
                              specialises in creating pre-commercial software prototypes and games
                              for entertainment and serious purposes.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part005.Breda-negative.webp`
      },
      {
            id: `${Prefixes.PARTNER_ID}006`,
            excluded: false,
            team: TeamNamesEnum.CFG,
            name: 'CFG',
            organisation: 'City Football Group',
            countryCode: CountryCodes.GreatBritain,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.cityfootballgroup.com/',
                  institutionalLink: 'https://www.cityfootballgroup.com/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part006.cfg.webp`,
            content: {
                  curriculum: (
                        <p>
                              Established in 2013, City Football Group is the owner of
                              football-related businesses in major cities around the world,
                              including football clubs, academies, technical support and marketing
                              companies. It is our ambition to increase participation in football on
                              and off the field, to find and develop the best footballing talent,
                              and to deliver an exciting and forward playing game. By achieving
                              these ambitions – playing attractive football, engaging our community
                              of passionate fans and adopting a uniquely global yet local approach –
                              we are growing a sustainable and socially responsible organisation,
                              consistent with what ‘City’ football has meant to people for over a
                              century.
                              <br />
                              Today, City Football Group is the world’s leading private owner and
                              operator of football clubs, with total or partial ownership of
                              thirteen clubs in major cities across the world: Premier League
                              Champions Manchester City in the UK, New York City FC in the US,
                              Melbourne FC in Australia, Yokohama F. Marinos in Japan, Montevideo
                              City Torque in Uruguay, Girona Futbol Club in Spain, Sichuan Jiuniu FC
                              in China, Mumbai City FC in India, Lommel SK in Belgium, ESTAC in
                              France, Palermo FC in Italy, Bahia SAF in Brazil and partner Club,
                              Club Bolivar.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part006.cfg-negative.webp`,
      },
      {
            id: `${Prefixes.PARTNER_ID}007`,
            excluded: false,
            team: TeamNamesEnum.LSO,
            name: 'CFG',
            organisation: 'The London Symphony Orchestra',
            countryCode: CountryCodes.GreatBritain,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.lso.co.uk/',
                  institutionalLink: 'https://www.lso.co.uk/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part007.lso.webp`,
            content: {
                  curriculum: (
                        <p>
                              The London Symphony Orchestra, established in 1904, is built on the
                              belief that extraordinary music should be available to everyone,
                              everywhere. Ranked among the world’s top orchestras, it is Resident
                              Orchestra at the Barbican, London, and reaches international audiences
                              through touring, digital broadcasts and recordings, including on its
                              own record label, LSO Live. A world-leading learning and community
                              programme, LSO Discovery, connects people from all walks of life to
                              the power of great music.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part007.lso-negative.webp`
      },
      {
            id: `${Prefixes.PARTNER_ID}008`,
            excluded: false,
            team: TeamNamesEnum.WUEB,
            name: TeamNamesEnum.WUEB,
            organisation: 'Wroclaw University of Economics ',
            countryCode: CountryCodes.Poland,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.lso.co.uk/',
                  institutionalLink: 'https://www.lso.co.uk/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part008.wueb.webp`,
            content: {
                  curriculum: (
                        <p>
                              Wroclaw University of Economics and Business (WUEB) is among Poland&#39;s
                              leading business higher education institutions, with a history of more
                              than 75 years of teaching and several prestigious international
                              accreditations. The WUEB staff actively participates in research and
                              educational activities involving business partners and stakeholders,
                              including brand-new initiatives like implementing VR in business
                              studies or hosting problem-solving Design Thinking marathons. WUEB has
                              hosted various international and national projects (completed or still
                              ongoing) including those financed by the EU (e.g. Horizon 2020,
                              Horizon Europe, Erasmus+), the National Science Centre, the Polish
                              Agency for Enterprise Development (e.g. POWER), and the National
                              Centre for Research and Development.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part008.wueb-negative.webp`
      },
      {
            id: `${Prefixes.PARTNER_ID}009`,
            excluded: false,
            team: TeamNamesEnum.UBISOFT,
            name: TeamNamesEnum.UBISOFT,
            organisation: 'Ubisoft Entertainment SA',
            countryCode: CountryCodes.France,
            social: {
                  email: '#!',
                  twitter: '#!',
                  linkedin: '#!',
                  personalWeb: 'https://www.ubisoft.com/en-us/',
                  institutionalLink: 'https://www.ubisoft.com/en-us/',
            },
            imageUrlPublic: `${PATHS.partnersImages}sqr_part009.ubisoft.webp`,
            content: {
                  curriculum: (
                        <p>
                              UBISOFT is a French company that ranks among the global leaders in the
                              creation, editing, and distribution of video games and interactive
                              services. Founded in 1986, the group has 20,000 employees spread
                              across 30 countries worldwide. UBISOFT is a creator of worlds,
                              committed to enriching players&#39; lives with original and memorable
                              entertainment experiences. Ubisoft&#39;s global teams create and develop a
                              deep and diverse portfolio of games, featuring brands such as
                              Assassin&#39;s Creed®, Brawlhalla®, For Honor®, Far Cry®, Tom Clancy&#39;s
                              Ghost Recon®, Just Dance®, Rabbids®, Tom Clancy&#39;s Rainbow Six®, The
                              Crew® and Tom Clancy&#39;s The Division®.
                        </p>
                  ),
            },
            mapInformation: {
                  isAdvisoryBoard: false,
                  mapLocation: { coordinates: [52.240464536149624, 21.018601198404188] },
            },
            bgImageForCard: EMPTY_STRING,
            negativeImage: `${PATHS.partnersImages}sqr_part009.ubisoft-negative.webp`
      },
];